import {
  ChangeDetectorRef,
  Component,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {SettingsComponent} from '../../components/settings/settings.component';
import {cookiesService} from '../../services/cookies.service';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'bilet-themes-page',
  templateUrl: './biletthemes.component.html',
  imports: [
    NgForOf,
    RouterLink

  ],
  styleUrl: './biletthemes.component.less'
})
export class BiletThemesPageComponent {


  constructor(public SettingsService: SettingsService, private cd: ChangeDetectorRef, private cookies: cookiesService, public BilletsService: BilletsService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private title: Title, private meta: Meta) {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });
  }



  ngOnInit(): void {
    this.title.setTitle('Темы билетов ПДД 2026 — все темы с последними изменениями и пояснениями  | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Изучайте все темы билетов ПДД 2026 по официальным вопросам ГИБДД. Дорожные знаки, разметка, перекрестки, приоритет, медицина, штрафы и другие темы с последними изменениями.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'темы билетов ПДД, ПДД 2026, темы ПДД, билеты ПДД 2026, экзамен ПДД, дорожные знаки, дорожная разметка, перекрестки, приоритет, сигналы светофора, основы безопасности, правила дорожного движения, вопросы ПДД, подготовка к экзамену ГИБДД'
    });
  }


}
